import { useContext } from "react";

import { useAdminDistributorsApi } from "../../../api/useAdminDistributorsApi";
import { DistributorListingContext } from "../../../context/DistributorListingContext";
import { CreateDistributorFormInputs } from "./CreateDistributorForm";

export const useCreateDistributorForm = () => {
    const { createDistributor } = useAdminDistributorsApi();
    const { addItem } = useContext(DistributorListingContext);

    const createDist = async (inputs: CreateDistributorFormInputs) => {
        const name = inputs.name;
        const alias = inputs.alias;

        const response = await createDistributor({ name, alias });

        addItem({
            id: response.entityId,
            name,
            alias,
            updatedDate: new Date().toISOString(),
            isModified: true
        });
    };

    return {
        createDist
    };
};
